import ContractDashboard from './contract-dashboard';

export default ContractDashboard;